import EpisodesStore from './store-episodes';
import SeasonsStore from './store-seasons';
import SheetStore from './store-sheet';
import ProviderVersionStore from './store-provider-version';

export class RootStore {
  seasonsStore: SeasonsStore;
  episodesStore: EpisodesStore;
  sheetStore: SheetStore;
  providerVersionStore: ProviderVersionStore;

  constructor() {
    this.seasonsStore = new SeasonsStore(this);
    this.episodesStore = new EpisodesStore(this);
    this.sheetStore = new SheetStore(this);
    this.providerVersionStore = new ProviderVersionStore(this);
  }
}

export const rootStore = new RootStore();
